<template>
  <v-row v-if="!readOnly && !field.readOnly" :ref="inputRef" class="text-no-wrap" align="center">
    <div :style="{background: fieldValue}" class="color-square ma-3" />
    <vue-color-compact v-if="field.compact" :value="fieldValue" style="width: 250px;" @input="changeColor" />
    <v-menu v-else
            v-model="menu"
            :disabled="field.disabled"
            class="reg-full-color-field"
            transition="scale-transition"
            offset-y
            bottom
            right>
      <template #activator="{ on, attrs }">
        <v-text-field v-model="fieldValue"
                      v-bind="attrs"
                      :class="field.class"
                      :hint="field.hint"
                      :persistent-hint="true"
                      :required="maybeCall(field.required, value)"
                      :label="label"
                      :rules="validationRules"
                      v-on="on"
                      @input="fieldChanged" />
      </template>
      <vue-color-sketch :value="fieldValue" @input="changeColor" />
    </v-menu>
  </v-row>
  <div v-else :class="{'reg-information': !small, 'reg-information-small': small}">
    <label>{{ field.label }}</label>
    <p><span :style="{background: fieldValue}" class="color-square" />{{ fieldValue }}</p>
  </div>
</template>

<script>
import { defineComponent, ref, toRef } from 'vue'
import { Sketch, Compact } from 'vue-color'
import { useDynamicField } from '../composables/useDynamicField'

export default defineComponent({
  name: 'DynamicColorSelect',
  components: {
    'vue-color-sketch': Sketch,
    'vue-color-compact': Compact
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    field: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    box: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    isValidating: {
      type: Boolean,
      default: false
    },
    itemKey: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'change'],
  setup(props, { emit, expose }) {
    const {
      fieldValue,
      validationRules,
      label,
      maybeCall,
      fieldChanged,
      setFieldValue,
      inputRef,
      hasError
    } = useDynamicField({
      value: toRef(props, 'value'),
      field: props.field,
      readOnly: props.readOnly,
      isValidating: toRef(props, 'isValidating'),
      itemKey: props.itemKey,
      emptyValue: props.field.default || '#000000',
      emit
    })

    const menu = ref(false)

    const changeColor = (value) => {
      if (value.hex) {
        setFieldValue(value.hex)
      } else {
        setFieldValue(props.field.default || '')
      }
    }

    // Expose properties for DynamicForm validation
    expose({
      hasError,
      validate: () => inputRef.value?.validate?.()
    })

    return {
      fieldValue,
      validationRules,
      label,
      maybeCall,
      fieldChanged,
      menu,
      changeColor,
      inputRef
    }
  }
})
</script>

<style lang="scss">
.color-square {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-right: 5px;
}

.reg-full-color-field {
  width: 100%;
}
</style>